import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowNext = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14.45075"
    height="13.901606"
    viewBox="0 0 14.45075 13.901606"
    version="1.1"
    id="svg1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs1" />
    <path
      d="M 14.45075,6.9508257 7.49994,0 6.17411,1.3258257 l 4.68754,4.6875 H 0 v 1.875 h 10.86165 l -4.68754,4.6874803 1.32583,1.3258 z"
      id="path1"
    />
  </svg>
);
export default SvgArrowNext;
